module.exports = __webpack_public_path__ + "img/622.b5ee27cc.jpg";